import LandingPage from "./components/LandingPage";
import LoginForm from "./components/LoginForm";
import Dashboard from "./components/Dashboard";
import SamlCallback from "./components/SamlCallback";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";

function App() {
    return (
        <AuthProvider>
            <Router basename={process.env.PUBLIC_URL}>
                <Routes>
                <Route path="/" element={<LandingPage />} />
                    <Route path="/login" element={<LoginForm />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/saml/callback" element={<SamlCallback />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;
